import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  onConfirm(): void {
    // Call the onConfirm callback if provided
    if (this.data && this.data.onConfirm) {
      this.data.onConfirm();
    } else {
      this.dialogRef.close(true);
    }
  }

  onCancel(): void {
    if (!this.isLoadingState) {
      this.dialogRef.close(false);
    }
  }

  get isLoadingState(): boolean {
    return this.data && this.data.isLoading ? this.data.isLoading() : false;
  }
}
